<button [class.checked]="checked" [class.disabled]="disabled" (click)="onToggle()" [disabled]="disabled">
  <div class="circle">
    @if (loading) {
      <oph-loading [diameter]="13" [strokeWidth]="1"></oph-loading>
    }
  </div>
</button>
